import { render, staticRenderFns } from "./HistoricoExpansionPanel.vue?vue&type=template&id=b0aa9cf0&"
import script from "./HistoricoExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./HistoricoExpansionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VExpandTransition,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VProgressLinear})
